import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { ResourcesConfig } from '@aws-amplify/core';
import { environment } from 'src/environments/environment';
import { TenantRepositoryService } from './tenant-repository.service';
import { ICognitoConfig } from '../interfaces/i-cognito-config';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { VersionService } from './version.service';
import { AmplifyTranslationsService } from './amplify-translations.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class AmplifyConfiguratorService {
  constructor(
    private _tenantRepository: TenantRepositoryService,
    private _router: Router,
    private _versionService: VersionService,
    private _amplifyTranslationsService: AmplifyTranslationsService,
    private _languageService: LanguageService
  ) {}

  public configured = false;

  public updateAmplifyConfig(newConfig: ResourcesConfig): void {
    this.configureAmplify(newConfig);
  }

  public async loadInitialAmplifyConfig(): Promise<void> {
    const tenant = localStorage.getItem('tenant');
    if (tenant) {
      try {
        const config: ICognitoConfig = await firstValueFrom(
          this._tenantRepository.getTenantInfo(tenant)
        );
        this._versionService.tenantName = config.friendlyName;
        this.updateAmplifyConfig({
          Auth: {
            Cognito: {
              userPoolClientId: config.appClientId,
              userPoolId: config.userPoolId,
              loginWith: {
                oauth: {
                  domain: environment.cognito.oauth_domain,
                  scopes: environment.cognito.oauth_scopes,
                  redirectSignIn: environment.cognito.oauth_redirect_sign_in,
                  redirectSignOut: environment.cognito.oauth_redirect_sign_out,
                  responseType: environment.cognito.oauth_response_type,
                },
              },
            },
          },
        });

        // Initialize Amplify translations with current language
        this._amplifyTranslationsService.initializeWithCurrentLanguage();
        this.configured = true;
      } catch (error) {
        console.error(error);
      }
    } else {
      const currentLang = this._languageService.getCurrentLanguageCode();
      this._router.navigateByUrl(`${currentLang}/no-tenant-fallback`);
    }
  }

  private configureAmplify(config: ResourcesConfig): void {
    Amplify.configure(config);
  }
}
